const KLAVIYO_COMPANY_ID = 'jTvF6K';
const KLAVIYO_LIST_ID = 'pcUr7t';
const KLAVIYO_STATIC_SCRIPT_URL = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${KLAVIYO_COMPANY_ID}`;
const KLAVIYO_BIS_SCRIPT_URL = 'https://a.klaviyo.com/media/js/onsite/onsite.js';

let loadPromise;
let initialized = false;
let preloadScheduled = false;

function delay(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

function loadScript(src) {
  const existingScript = document.querySelector(`script[src="${src}"]`);
  if (existingScript) {
    if (existingScript.dataset.loaded === 'true') return Promise.resolve();

    return new Promise((resolve, reject) => {
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      script.dataset.loaded = 'true';
      resolve();
    };
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.append(script);
  });
}

function initializeBackInStock() {
  if (initialized) return;

  window.klaviyo = window.klaviyo || [];
  window.klaviyo.init({
    account: KLAVIYO_COMPANY_ID,
    list: KLAVIYO_LIST_ID,
    platform: 'shopify',
  });
  window.klaviyo.enable('backinstock', {
    trigger: {
      product_page_text: 'Notify Me When Available',
      product_page_class: 'klaviyo-bis-trigger',
      product_page_text_align: 'center',
      product_page_margin: '0px',
      replace_anchor: true,
    },
    modal: {
      subscribe_checked: true,
      newsletter_subscribe_label:
        'Be the first to know about new product launches, special promotions, sales and more.',
      headline: '<strong>BACK IN STOCK NOTIFICATION</strong>',
      body_content: "Enter your email and we'll let you know when this item is back in stock!",
      email_field_label: 'Email',
      button_label: 'NOTIFY ME WHEN AVAILABLE',
      subscription_success_label: "You're in! We'll let you know when it's back.",
      footer_content: '',
      font_family: '"Lato","HelveticaNeue","Helvetica Neue",sans-serif;',
      additional_styles:
        "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue'); button.close.klaviyo-bis-close{top:0px; right:8px;} body.klaviyo-bis-close .modal-title {font-size:20px; text-align:center;} body.klaviyo-bis-close #container{padding: 30px 18px 20px 18px; }body.klaviyo-bis-close { position:relative;}#klaviyo-bis-modal{position:absolute; top:50%;left:50%;transform:translate(-50%,-50%); width:98%; max-width:500px;}",
      drop_background_color: '#111',
      background_color: '#fff',
      text_color: '#111',
      button_text_color: '#fff',
      button_background_color: '#111',
      close_button_color: '#ccc',
      error_background_color: '#fcd6d7',
      error_text_color: '#C72E2F',
      success_background_color: '#d3efcd',
      success_text_color: '#111',
    },
  });

  initialized = true;
  window.dispatchEvent(new CustomEvent('custom-pdp:klaviyo-bis-ready'));
}

function loadBackInStock() {
  if (!loadPromise) {
    loadPromise = loadScript(KLAVIYO_STATIC_SCRIPT_URL)
      .then(() => loadScript(KLAVIYO_BIS_SCRIPT_URL))
      .then(() => initializeBackInStock());
  }

  return loadPromise;
}

window.customPdpIsKlaviyoBisReady = function customPdpIsKlaviyoBisReady() {
  return initialized;
};

function preloadBackInStock() {
  return loadBackInStock().catch((error) => {
    console.error(error);
    throw error;
  });
}

function scheduleBackInStockPreload() {
  if (preloadScheduled || loadPromise) return;

  preloadScheduled = true;
  const preload = () => {
    preloadScheduled = false;
    preloadBackInStock();
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(preload, { timeout: 1500 });
    return;
  }

  window.setTimeout(preload, 250);
}

function getKlaviyoModal() {
  return document.querySelector('#klaviyo-bis-modal, .klaviyo-bis-modal, [data-testid="klaviyo-bis-modal"]');
}

function isKlaviyoModalOpen() {
  const modal = getKlaviyoModal();
  if (!(modal instanceof HTMLElement)) return false;

  const style = window.getComputedStyle(modal);
  const rect = modal.getBoundingClientRect();

  return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
}

function dispatchKlaviyoTriggerClick(trigger) {
  trigger.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
}

window.customPdpOpenKlaviyoBis = async function customPdpOpenKlaviyoBis(trigger) {
  if (!(trigger instanceof HTMLElement)) return false;

  try {
    await loadBackInStock();
  } catch (error) {
    console.error(error);
    return false;
  }

  dispatchKlaviyoTriggerClick(trigger);
  await delay(500);

  return isKlaviyoModalOpen();
};

window.customPdpPreloadKlaviyoBis = function customPdpPreloadKlaviyoBis({ immediate = false } = {}) {
  if (immediate) {
    return preloadBackInStock();
  }

  scheduleBackInStockPreload();
  return loadPromise || Promise.resolve();
};
